var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "amex-svgrepo-com",
    transform: "translate(0 -41.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98622",
    "data-name": "Path 98622",
    d: "M2.125,41.025h29.75A2.107,2.107,0,0,1,34,43.113V62.938a2.107,2.107,0,0,1-2.125,2.087H2.125A2.106,2.106,0,0,1,0,62.938V43.113A2.107,2.107,0,0,1,2.125,41.025Z",
    fill: "#26a6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98623",
    "data-name": "Path 98623",
    d: "M21.593,113.966l-3.358,7.3h4.019l.5-1.163h1.139l.5,1.163h4.424v-.888l.394.888H31.5l.394-.907v.907h9.2l1.119-1.133,1.048,1.133,4.726.009-3.368-3.637,3.368-3.669H43.332l-1.089,1.112-1.015-1.112H31.219l-.86,1.883-.88-1.883H25.469v.858l-.446-.858ZM22.37,115H24.33l2.227,4.948V115H28.7l1.72,3.548L32.008,115h2.136v5.236h-1.3l-.011-4.1-1.894,4.1H29.777l-1.905-4.1v4.1H25.2l-.507-1.174H21.954l-.506,1.173H20.016Zm12.962,0h5.284l1.616,1.714L43.9,115h1.616l-2.455,2.632,2.455,2.6H43.828L42.211,118.5l-1.677,1.734h-5.2V115Zm-12.009.886-.9,2.091h1.8Zm13.314.2v.956H39.52v1.065H36.638v1.043h3.233l1.5-1.537-1.439-1.529h-3.3Z",
    transform: "translate(-16.11 -64.594)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.8165a108afb35fc238a229912109541d.svg";
export { ForwardRef as ReactComponent };